import { SimpleGrid } from '@mantine/core';
import React from 'react';

interface Props {
  children: React.ReactNode;
}

export const FullGridContainer = ({ children }: Props) => {
  return <SimpleGrid cols={1}>{children}</SimpleGrid>;
};

export const HalfGridContainer = ({ children }: Props) => {
  return (
    <SimpleGrid
      cols={{ base: 1, md: 2 }}
      spacing={{ base: 'sm', md: 'xl' }}
      verticalSpacing="sm"
    >
      {children}
    </SimpleGrid>
  );
};

export const OneThirdGridContainer = ({ children }: Props) => {
  return (
    <SimpleGrid
      cols={{ base: 1, md: 3 }}
      spacing={{ base: 'sm', md: 'xl' }}
      verticalSpacing="sm"
    >
      {children}
    </SimpleGrid>
  );
};

export const OneQuarterGridContainer = ({ children }: Props) => {
  return (
    <SimpleGrid
      cols={{ base: 1, sm: 2, md: 4 }}
      spacing={{ base: 'sm', md: 'xl' }}
      verticalSpacing="sm"
    >
      {children}
    </SimpleGrid>
  );
};
